import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { DeletionRequestsHttpClient } from './deletion-requests-http-client';
import { DeletionRequestsActions } from './deletion-requests.store';

@Injectable({ providedIn: 'root' })
export class DeletionRequestsEffects {
  private readonly deletionRequestsService = inject(DeletionRequestsHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(DeletionRequestsActions, this.actions$);

  public fetchAccountDeletionRequestCollection$ = this.effects(DeletionRequestsActions.fetch, () =>
    this.deletionRequestsService.fetchDeletionRequests(),
  );
}
